module.exports = __webpack_public_path__ + "img/symbol_1.1a6f5b90.png";